export default "__VITE_ASSET__7284f931__"